/**
 * Created by mateimisarca on 20.03.2021
 */

import SubscriptionsAdminPage from './subscriptions-admin-page';

export default SubscriptionsAdminPage;
